import React, { useEffect, useState } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { MasterMessage } from '../../../../masters/masterMessages';
import Swal from 'sweetalert2';
import ListView from '../../../components/views/listView';
import ModalLoading from '../../../components/general/loading/modalLoading';
import DropZoneField from '../../../components/general/fields/dropzoneField';
import Grid from '@mui/material/Grid';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';
import {
    asyncGetLists,
    asyncPostLoadBase,
} from '../../../../services/commercialCrm.service';
import AutocompleteField from '../../../components/general/fields/autoCompleteField';
import { CSVRender } from '../../../components/csvViewer/csvViewer';
import { RootState } from '../../../../redux/store';
import { useSelector } from 'react-redux';
import { Checkbox, FormControlLabel } from '@mui/material';
import { requiredFields } from './fields';
import { VerifyReplace } from './verifyReplace';

const LoadBaseBrightpattern = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const {
        titleListBP,
        messageError,
        titleModalLoading,
        messageModalLoading,
    } = MasterMessage.commercialCrm.loadBase;
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState<any>([]);
    const [lists, setLists] = useState<any[]>();
    const [list, setList] = useState<string>();
    const [showCsvViewer, setShowCsvViewer] = useState(false);
    const [loadOnlyInDB, setLoadOnlyInDB] = useState(false);
    const [showVerifyReplace, setShowVerifyReplace] = useState(false);

    const handleVerifyReplace = () => {
        setShowCsvViewer(false);
        setShowVerifyReplace(true);
    };

    const handleSave = (deleteAndSave: boolean) => {
        setShowVerifyReplace(false);
        if (files.length > 0 && Boolean(list)) {
            setLoading(true);
            setList(undefined);
            setFiles([]);
            setLoadOnlyInDB(false);
            asyncPostLoadBase(files[0], list || '', loadOnlyInDB, deleteAndSave)
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setLoading(false);
                        Swal.fire({
                            title: 'Carga Exitosa',
                            text: `
                                Se cargaron ${body.items.added} de ${body.items.total} registros exitosamente,
                                donde se econtrarón ${body.items.duplicateKey} duplicados y
                                ${body.items.missingKey} con problemas en sus claves.`,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            allowOutsideClick: false,
                            customClass: 'swal-wide-class',
                        });
                    } else {
                        Swal.fire({
                            title: 'Error Carga',
                            text: messageError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                            confirmButtonColor: '#1d1d1d',
                            customClass: 'swal-wide-class',
                        });
                    }
                })
                .finally(() => setLoading(false));
        } else {
            SwalCustomClass.fire({
                text: 'Debe seleccionar un archivo y una lista',
                icon: 'error',
                iconColor: '#1d1d1d',
            });
        }
    };

    useEffect(() => {
        (async () => {
            const { items } = await asyncGetLists();
            setLists(items.map((item) => ({ id: item, name: item })));
        })();
    }, []);

    return (
        <>
            {loading ? (
                <ModalLoading
                    open
                    title={titleModalLoading}
                    message={messageModalLoading}
                />
            ) : (
                <>
                    <ListView
                        title={titleListBP}
                        titleButtonAdd={'Cargar'}
                        onClickAdd={() => setShowCsvViewer(true)}
                        startIconButtonAdd={
                            <FileUploadIcon color="secondary" />
                        }
                        disableBack
                        disableDataGrid
                        disabledAdd={!Boolean(list) || !files[0]}
                    />
                    <CSVRender
                        file={files[0]?.get('file')}
                        open={showCsvViewer}
                        onCloseCsvViewer={() => setShowCsvViewer(false)}
                        onAccept={handleVerifyReplace}
                        requiredFields={requiredFields}
                    />
                    <VerifyReplace
                        open={showVerifyReplace}
                        onCloseCsvViewer={() => setShowVerifyReplace(false)}
                        onAccept={handleSave}
                    />
                    {type === 'admin' && (
                        <Grid
                            item
                            xs={12}
                            mt={3}
                            display="flex"
                            justifyContent="center"
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className="checkbox_boot"
                                        id="loadOnlyInDB"
                                        name="loadOnlyInDB"
                                        checked={loadOnlyInDB}
                                        onChange={() =>
                                            setLoadOnlyInDB(!loadOnlyInDB)
                                        }
                                    />
                                }
                                label="¿Cargar solo en base de datos?"
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} mt={type === 'admin' ? 0 : 3}>
                        <AutocompleteField
                            data={lists}
                            label="Selecciona una lista"
                            name="list"
                            size="small"
                            required
                            value={list}
                            onChangeValue={(value) => setList(value)}
                        />
                    </Grid>
                    <Grid
                        container
                        spacing={{ xs: 1.5, md: 1.5 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12} mt={3} sx={{ minWidth: 300 }}>
                            <DropZoneField
                                name="File"
                                maxFiles={1}
                                accept=".csv"
                                onChange={(value) => setFiles(value)}
                            />
                        </Grid>
                    </Grid>
                </>
            )}
        </>
    );
};

export default LoadBaseBrightpattern;
